import { render, staticRenderFns } from "./TensionsView.vue?vue&type=template&id=7ea21764&"
import script from "./TensionsView.vue?vue&type=script&lang=js&"
export * from "./TensionsView.vue?vue&type=script&lang=js&"
import style0 from "./TensionsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports